// removed by extract-text-webpack-plugin
module.exports = {"icon":"identityIcon_icon_1NCUmmgT8Y"};


//////////////////
// WEBPACK FOOTER
// ./IdentityIcon/identityIcon.css
// module id = 502
// module chunks = 0